import React, { useState } from "react";
import { Box, Grid, TextField, Button, Typography, Paper, Divider } from "@mui/material";
import { Email, Phone, AccessTime } from "@mui/icons-material";
import Swal from 'sweetalert2';
import { enviarContacto } from "../services/contactoService";


const ContactForm = () => {
  // Estado del formulario
  const [formData, setFormData] = useState({
    Nombre: "",
    Correo: "",
    Mensaje: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    setSuccessMessage("");
    setFieldErrors({});

    try {
      await enviarContacto(formData);

      Swal.fire({
        title: '¡Éxito!',
        text: 'Contacto guardado correctamente',
        icon: 'success',
        confirmButtonText: 'OK'
      });

      setFormData({ Nombre: "", Correo: "", Mensaje: "" });
    } catch (error) {
      const apiError = error.response?.data || error;
      if (apiError.messages) {
        setFieldErrors(apiError.messages);
      } else {
        setErrorMessage(apiError.message || "Error al enviar el formulario");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ flexGrow: 1, pb: { xs: 6, md: 10 }, px: { xs: 2, sm: 3 }, backgroundColor: "white", maxWidth: 1150, mx: "auto" }}>
      <Grid container spacing={{ xs: 2.5, md: 4 }}>
        {/* Formulario */}
        <Grid item xs={12} md={6}>
          <Paper elevation={2} sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5 }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ fontSize: { xs: "1.35rem", md: "1.5rem" } }}>
              Por favor, rellene el siguiente formulario.
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Nombre"
                variant="outlined"
                margin="normal"
                name="Nombre"
                value={formData.Nombre}
                onChange={handleChange}
                error={!!fieldErrors.Nombre}
                helperText={fieldErrors.Nombre}
              />
              <TextField
                fullWidth
                label="Correo electrónico"
                variant="outlined"
                margin="normal"
                name="Correo"
                value={formData.Correo}
                onChange={handleChange}
                error={!!fieldErrors.Correo}
                helperText={fieldErrors.Correo}
              />
              <TextField
                fullWidth
                label="Mensaje"
                variant="outlined"
                multiline
                rows={4}
                margin="normal"
                name="Mensaje"
                value={formData.Mensaje}
                onChange={handleChange}
                error={!!fieldErrors.Mensaje}
                helperText={fieldErrors.Mensaje}
              />
              {errorMessage && <Typography color="error">{errorMessage}</Typography>}
              {successMessage && <Typography color="success">{successMessage}</Typography>}
              <Button type="submit" variant="contained" color="success" fullWidth sx={{ mt: 2, py: 1.2, fontWeight: 700 }} disabled={isLoading}>
                {isLoading ? "Enviando..." : "Enviar"}
              </Button>
            </form>
          </Paper>
        </Grid>
        {/* Información de contacto */}
        <Grid item xs={12} md={6}>
          <Paper elevation={0} sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, border: "1px solid", borderColor: "divider", height: "100%" }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Antes de contactarnos
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom sx={{ lineHeight: 1.7 }}>
              Antes de enviarnos tu consulta, te invitamos a revisar nuestra sección de preguntas frecuentes y los servicios que ofrecemos. Esto nos permitirá brindarte una atención más rápida y precisa.
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Información de contacto
            </Typography>
            <Typography variant="body2" display="flex" alignItems="center" gutterBottom sx={{ lineHeight: 1.6 }}>
              <Phone sx={{ mr: 1, color: 'forestgreen' }} /> +57 315-606-6418
            </Typography>
            <Typography variant="body2" display="flex" alignItems="center" gutterBottom sx={{ lineHeight: 1.6 }}>
              <Email sx={{ mr: 1, color: 'forestgreen' }} /> marojasm@itc.edu.co
            </Typography>
            <Typography variant="body2" display="flex" alignItems="center" gutterBottom sx={{ lineHeight: 1.6 }}>
              <AccessTime sx={{ mr: 1, color: 'forestgreen' }} /> Todos los días de 9:00 a 17:00
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactForm;
